module.exports = __webpack_public_path__ + "215b45ab8f8f6c1cccbbadf715e6b741.svg";